<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <TabNav :links="routesNav" />
    </div>

    <div class="container-body">

        <div class="table-toolbar">
            <div class="toolbar-left">
                <label>
                    Mostrar registros:
                    <select v-model="pageSize" @change="onPageSizeChange">
                        <option :value="10">10</option>
                        <option :value="15">15</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </select>
                </label>
            </div>
            <div class="toolbar-right">
                <label>
                    Buscar:
                    <input
                        type="text"
                        v-model="searchQuery"
                        @keyup="onSearchKeyup"
                        placeholder="Buscar grupo..."
                    />
                </label>
            </div>
            <div class="toolbar-clear">
                <button
                    v-if="hasActiveFilters"
                    type="button"
                    class="filters-clear-btn"
                    @click="clearFilters"
                >
                    Limpiar filtros
                </button>
            </div>
        </div>

        <table class="groups-table">
            <thead>
                <tr>
                    <th class="sortable" @click="onSort('name')">
                        Nombre <font-awesome-icon :icon="getSortIcon('name')" />
                    </th>
                    <th class="sortable" @click="onSort('desc')">
                        Descripción <font-awesome-icon :icon="getSortIcon('desc')" />
                    </th>
                    <th class="sortable" @click="onSort('created_at')">
                        Fecha creación <font-awesome-icon :icon="getSortIcon('created_at')" />
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in groups" v-bind:key="item.id">
                    <td>
                        <router-link :to="'/usuarios/grupos-de-usuarios/' + item.id">{{item.name}}</router-link>
                    </td>
                    <td>{{item.desc || '—'}}</td>
                    <td>{{groupDateFormatter(item.created_at)}}</td>
                </tr>
                <tr v-if="!groups || groups.length === 0">
                    <td colspan="3" class="empty-message">No hay grupos</td>
                </tr>
            </tbody>
        </table>

        <Pagination
        v-show="totalPages!=0"
        v-bind:totalPages="totalPages"
        v-bind:currentPage="currentPage"
        v-bind:pageSize="pageSize"
        v-on:pagechanged="pageChangedClick"
        >
        </Pagination>

    </div>

</main>
</template>

<script>
// @ is an alias to /src
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import Pagination from '@/components/Pagination.vue'

import {formatter} from '@/components/mixin/formatter.js'
import {pagination} from '@/components/mixin/pagination.js'
import {restGroup} from '@/components/mixin/restGroup.js'

export default{
    name: 'test',
    mixins: [formatter, pagination, restGroup],
    data(){
        return{
            searchQuery: '',
            sortKey: '',
            sortOrder: 'asc',
            debounceTimer: null
        }
    },
    components:{
        SideNav,
        Breadcrumb,
        Pagination,
        TabNav
    },
    computed: {
        hasActiveFilters: function(){
            return this.searchQuery !== '' || this.sortKey !== ''
        },
        routesNav: function(){
          return [
                {name:'Opciones'},
                {name:'Crear grupo' , path: '/usuarios/grupos-de-usuarios/nuevo-grupo'}
              ]
        },
        routesBread: function(){
          return [
                {name: 'Usuarios', path: '/usuarios'},
                {name: 'Grupos'},
          ]
        }
    },
    props: [],
    methods:{
        fetchGroups: function(){
            this.getGroupsPages(this.currentPage, this.searchQuery, this.sortKey, this.sortOrder, this.pageSize)
        },
        onPageSizeChange: function(){
            this.currentPage = 1
            this.fetchGroups()
        },
        pageChangedClick: function (page){
            this.currentPage = page;
            this.fetchGroups();
        },
        onSearchKeyup: function(){
            clearTimeout(this.debounceTimer)
            this.debounceTimer = setTimeout(() => {
                this.currentPage = 1
                this.fetchGroups()
            }, 300)
        },
        onSort: function(key){
            if (this.sortKey === key) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
            } else {
                this.sortKey = key
                this.sortOrder = 'asc'
            }
            this.currentPage = 1
            this.fetchGroups()
        },
        getSortIcon: function(key){
            if (this.sortKey !== key) return 'sort'
            return this.sortOrder === 'asc' ? 'sort-up' : 'sort-down'
        },
        clearFilters: function(){
            clearTimeout(this.debounceTimer)
            this.searchQuery = ''
            this.sortKey = ''
            this.sortOrder = 'asc'
            this.currentPage = 1
            this.fetchGroups()
        },
        groupDateFormatter: function(date){
            if (!date || this.moment(date).year() <= 1) return '—'
            //Con hora: sin ella no se distingue el orden de dos grupos creados el mismo día
            return this.dateTimeFormatter(date)
        }
    },
    updated () {

    },
    created () {
        //Verificar permisos
        this.$store.getters.getPermissions.users? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.fetchGroups()
    }
}
</script>

<style lang="scss" scoped>
.table-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 1em;
  margin-bottom: 1em;
}

/* Empuja el resto de la barra a la derecha, igual que en el listado de usuarios */
.toolbar-left {
  margin-right: auto;
}

.toolbar-left,
.toolbar-right,
.toolbar-clear{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.75em;
}

.table-toolbar label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.toolbar-right input {
    width: 100%;
    max-width: 220px;
    min-width: 180px;
}

.groups-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}

.groups-table th,
.groups-table td {
  padding: 0.6em 0.8em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  text-align: left;
  vertical-align: middle;
  font-size: 0.875em;
}

.groups-table thead th {
  background: var(--color-navy);
  color: #fff;
  white-space: nowrap;
  font-weight: 600;
}

/* La fecha con hora es larga: sin esto parte en dos líneas y desalinea la fila */
.groups-table td:last-child {
  white-space: nowrap;
}

.groups-table th.sortable {
  cursor: pointer;
  user-select: none;
}

.groups-table th.sortable:hover {
  background: var(--color-steel);
}

.groups-table tbody tr:hover {
  background: rgba(59, 110, 148, 0.06);
}

.empty-message {
  padding: 2em !important;
  color: #6b7280;
  text-align: center !important;
}
</style>
